// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"21f559069eecaa185d4f","293":"d12b93f1f445324c4b5d","461":"c926b3ede24cc1c1e04a","518":"1079aeb76440880138b1","779":"7c68245e1b2b9d1dd719"}[chunkId] + ".js";
};